import {
  ROUTER_PATHS,
  useTableServerSideFiltering,
  useTableFilter,
  useUploadFile,
  EstadoCuadreENUM,
  hasPermission
} from "@/shared";
import { regenerarPdfCuadreInventario, useFetchGetCuadreInventario, useFetchPutCuadreInventario } from "@/shared/actions/erp/inventario/cuadre.actions";
import { GeneralTable } from "@/shared/components/ui";
import { ICuadreInventario } from "@/shared/interfaces/erp/inventario/cuadre-inventario.interface";
import { useNavigate } from "react-router-dom";
import useTableColumnsCuadre from "../../hook/useTableColumnsCuadre";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { ChangeCircle, CloudDownload, Edit } from "@mui/icons-material";
import { useUiStore } from "@/store/ui";
import { PermissionsEnum } from "@/auth/interfaces";
import { toast } from "react-toastify";

interface TableCuadreInventarioProps {
  estado_cuadre: string
  actionEdit: boolean
}
export default function TableCuadreInventario({
  actionEdit,
  estado_cuadre
}: TableCuadreInventarioProps) {

  const returnUrlCountries = ROUTER_PATHS.inventario.cuadreInventarioNav;
  const {
    descargarPdfDesdeurl
  } = useUploadFile();


  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);


  const navigate = useNavigate();

  // server side filters - colums table

  const {
    columns
  } = useTableColumnsCuadre();

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  ///* table
  const {
    pagination,
    searchTerm,
    setPagination,
  } = useTableFilter();

  const {
    pageIndex,
    pageSize
  } = pagination;


  ///* fetch data
  const {
    data: cuadreRes,
    isLoading,
    isRefetching,
  } = useFetchGetCuadreInventario({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      nombre: searchTerm,
      estado_cuadre_in: estado_cuadre,
      ...filterObject,
      filterByState: false,
    }
  });

  const {
    mutateAsync: putCuadre
  } = useFetchPutCuadreInventario();

  ///* handlers
  const onEdit = (original: ICuadreInventario) => {
    navigate(`${returnUrlCountries}/editar/${original.id_cuadre}`);
  };

  const onDownload = async (original: ICuadreInventario) => {
    let url = original.url_cuadre;
    try {
      const res = await regenerarPdfCuadreInventario(original.id_cuadre);
      url = res?.data?.url_cuadre ?? url;
    } catch (error) {
      toast.warning('No se pudo regenerar, se descargará la versión anterior.');
    }
    // descargarPdfDesdeurl(original.url_cuadre, `informe_cuadre_${original.numero_referencia}`)
    descargarPdfDesdeurl(url ? `${url}?t=${Date.now()}` : url,
      `informe_cuadre_${original.numero_referencia}`);
  };

  const onRevert = (original: ICuadreInventario) => {
    setConfirmDialogIsOpen(true);

    setConfirmDialog({
      isOpen: true,
      title: 'Revertir cuadre',
      subtitle: '¿Estás seguro de que deseas revertir este cuadre?',
      onConfirm: () => {
        putCuadre({
          id: original.id_cuadre,
          data: {
            estado_cuadre: EstadoCuadreENUM.REVERSAR,
          } as any
        });

        setConfirmDialogIsOpen(false);

      },
      onClose: () => {
        setConfirmDialogIsOpen(false);
      },
    });
  };

  return (
    <GeneralTable<ICuadreInventario>
      columns={columns}
      data={cuadreRes?.data?.data || []}
      //
      isLoading={isLoading}
      isRefetching={isRefetching}
      // // search
      enableGlobalFilter={false}
      // onGlobalFilterChange={setGlobalFilter}
      // // filters - llega al back
      enableManualFiltering={true}
      columnFilters={columnFilters}
      onColumnFiltersChange={setColumnFilters}
      // // pagination
      pagination={pagination}
      onPaging={setPagination}
      rowCount={cuadreRes?.data?.count}
      // // actions ========
      actionsColumnSize={actionEdit ? 80 : 130}
      positionActionsColumn="first"
      // crud
      //onEdit={onEdit}
      enableEditing={true}
      canEdit={false}

      canDelete={false}
      showCustomActionBtnSpace={true}
      enableColumnActions={true}
      customActionBtnSpace={(value) => {
        return (
          <Grid container justifyContent={'center'} spacing={1}>

            {
              actionEdit && (
                <Grid item>
                  <IconButton
                    size="large"
                    sx={{
                      color: 'primary.main',
                    }}
                    color="default"
                    onClick={() => onEdit(value)}>
                    <Edit />
                  </IconButton>
                </Grid>
              )
            }


            {
              !actionEdit && (
                <Grid item>
                  <Tooltip title={'Descargar informe de cuadre'}>
                    <IconButton
                      size="large"
                      color="success"
                      onClick={() => onDownload(value)}
                      sx={{
                        color: 'success.main',
                      }}
                    >
                      <CloudDownload />
                    </IconButton>
                  </Tooltip>
                </Grid>
              )
            }

            {
              (hasPermission(PermissionsEnum.reversar_cuadre_inventario) && !actionEdit) && (
                <Grid item>
                  <Tooltip title={'Revertir cuadre'}>
                    <IconButton
                      size="large"
                      color="primary"
                      onClick={() => onRevert(value)}
                      sx={{
                        color: 'primary.main',
                      }}
                    >
                      <ChangeCircle />
                    </IconButton>
                  </Tooltip>
                </Grid>
              )
            }


          </Grid>
        )
      }}

    // onDelete={onDelete}
    />
  )


}